import _ from 'lodash';

import { DropdownOption } from '../../types/entities';

export function generateProjectOptions<T extends { id: string; name: string }>(
  allProjectsOption: DropdownOption,
  projects: T[],
): DropdownOption[] {
  const projectsOptions = _.map(projects, ({ id, name }: T) => ({
    id,
    value: name,
  }));

  return [allProjectsOption, ...projectsOptions];
}
